//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TimelineCard from "./utils/timeline-card.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineAccountCreation",
  components: {
    TimelineCard
  },
  props: {
    details: {
      type: Object,
      required: true
    },
    subscribers: {
      type: Array,
      default: () => []
    },
    createdAt: {
      type: String,
      default: ""
    }
  }
});